var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cycle-container"},[_c('transition',{attrs:{"css":false},on:{"enter":_vm.handleEnter,"leave":_vm.handleLeave}},[(_vm.showItem)?_c('div',{key:_vm.currentIndex,staticClass:"animated-text"},[_vm._v(" "+_vm._s(_vm.currentText)+" ")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }